import { Injectable, inject } from '@angular/core';
import { UserService } from 'web-common/src/app/user/user.service';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { WindowService } from 'web-common/src/app/window.service';
import { Observable, Observer } from 'rxjs';

@Injectable()
export class AdminUserGuard {

  constructor(private userService: UserService, private windowService: WindowService) {}

  canActivate(): Observable<boolean> {
    return this.isInstitutionalAdmin();
  }

  private isInstitutionalAdmin(): Observable<boolean> {
    return new Observable((observer: Observer<boolean>) => {
      this.userService.fetchUser().subscribe(user => {
        if (user && user.account && user.account.disabled) {
          this.redirectToDisabledScreen();
          observer.next(false);
          observer.complete();
          return;
        }
        if (user.isInstitutionAdmin && user.discountGroup.groupSettings.subscriptionType === true) {
          observer.next(true);
          observer.complete();
        } else if (user.isInstitutionAdmin && !user.discountGroup.groupSettings.subscriptionType) {
          this.redirectToNonSubscriberPage();
        } else {
          this.redirectToLibrary();
        }
      });
    });
  }

  private redirectToNonSubscriberPage() {
    this.windowService.nativeWindow.location.href = '/admin/non-subscriber';
  }

  private redirectToDisabledScreen() {
    this.windowService.nativeWindow.location.href = '/login/disabled/';
  }

  private redirectToLibrary() {
    this.windowService.nativeWindow.location.href = '/';
  }

}

export const canActivateAdminUser: CanActivateFn =
    (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
      return inject(AdminUserGuard).canActivate();
    };
